module.exports = __webpack_public_path__ + "img/valvula_vc38.40b9f925.jpg";